import React, { useState, useMemo, useEffect } from 'react';
import dynamic from 'next/dynamic';
import NewsletterV2 from './NewsletterV2';
import {
  BuildServerlessBookCoverImageUrl,
  SiteColors,
} from '../../helpers/Helper';
const Image = dynamic(() => import('../Image/Image'));
import { _SITEID_SITE_NAME_MAP_ } from '../../helpers/Helper';
import CheckBox from '../../components/CheckBox/CheckBox';

import "./NewsletterV2WithImage.css";

const NewsletterV2WithImage = (props) => {
  const [showSuccessMessage, setShowSuccessMessage] = useState(false);
  const [imageUrl, setImageUrl] = useState('');
  const [isOptInChecked, setIsOptInChecked] = useState(
    props?.optInNewsletter?.partnerCheckbox !== false ? true : false
  );

  useEffect(() => {
    let imageUrl = '';
    let imageWidth = 220;
    let imageHeight = 0;
    if (props.isMobile) {
      imageWidth = 140;
      imageHeight = 0;
    }
    if (props?.modalWithImageProps?.type === 'bookImage') {
      imageUrl = BuildServerlessBookCoverImageUrl(
        { width: imageWidth, height: imageHeight },
        props.modalWithImageProps?.image?.url
      );
    } else {
      imageUrl = `${process.env.S3_IMAGE_URL}/sm_${props.modalWithImageProps?.image?.url}`;
    }
    setImageUrl(imageUrl);
  }, [props.modalWithImageProps?.type]);

  const getSignUpStatus = (status) => {
    if (status) {
      setShowSuccessMessage(true);
    } else {
      setShowFailureMessage(false);
    }
  };

  const renderSuccessMessage = () => (
    <div className="success-message">
      <div className="success-message_main_content">
        <p>You're one of</p> <p>us now!</p>
      </div>
      <div className="success-message_sub_content">
        <p>check your inbox for a</p>
        <p>welcome message</p>
      </div>
    </div>
  );

  const renderImage = useMemo(() => {
    if (!showSuccessMessage) {
      return (
        <Image
          ImageUrl={imageUrl}
          Title={props.modalWithImageProps?.image?.title}
          Alt_Text={
            props.modalWithImageProps?.image?.altText ||
            props.modalWithImageProps?.image?.title
          }
          width={
            props?.modalWithImageProps?.type === 'upload'
              ? props.isMobile
                ? '150'
                : '220px'
              : ''
          }
        />
      );
    }
  }, [
    showSuccessMessage,
    imageUrl,
    props.modalWithImageProps?.image?.title,
    props.modalWithImageProps?.image?.altText,
  ]);

  const renderNewsletter = () => (
    <NewsletterV2
      {...props}
      buttonText="SIGN UP"
      textBoxPlaceholder="Enter email address here"
      getSignUpStatus={getSignUpStatus}
      isOptInChecked={isOptInChecked}
    />
  );

  const handleOptInChange = (evt) => {
    setIsOptInChecked(evt.target.checked);
  };

  const renderOptIn = () => {
    if (
      props?.optInNewsletter?.optInSite &&
      props?.optInNewsletter.optInNewsletterCopy.trim()
    ) {
      return (
        <div style={{ margin: '0.5rem', background: '#b9e0ff', padding: '0.5rem' }}>
          <div style={{marginTop: '10px'}}>
            <CheckBox
              isChecked={isOptInChecked}
              onChange={handleOptInChange}
              value={props?.optInNewsletter.optInNewsletterCopy}
              label={props?.optInNewsletter.optInNewsletterCopy}
            />
          </div>
        </div>
      );
    } else {
      return <div></div>;
    }
  };

  return (
    <div 
      className="newsletterv2_with_image"
      style={{
        "--newsletterv2_with_image-border": showSuccessMessage ? 'none' : `1px solid ${SiteColors(props?.siteId)}`,
        "--newsletterv2_with_image-width": showSuccessMessage ? '94%' : '100%',
        "--newsletter_with_image_button-bg-color": SiteColors(props.siteId),
      }}
    >
      <div>
        <div className="newsletterv2_image_nl">
          {!showSuccessMessage && renderImage}
          {!showSuccessMessage && renderNewsletter()}
        </div>
        {!showSuccessMessage && renderOptIn()}
      </div>
      {showSuccessMessage && renderSuccessMessage()}
    </div>
  );
};

export default NewsletterV2WithImage;
